import React from "react";
import "./Home.css";
import PlayStoreButton from "../button/playstore/PlayStoreButton";

const HomePage = () => {
  return (
    <section className="home-container">
      <div className="home-content">
        <div className="home-text">
          <h1 className="home-title">Welcome to GrowTube</h1>
          <p className="home-description">
          GrowTube helps you share your content and connect with a community of creators. By embedding videos and encouraging genuine interest, you can enhance your channel's presence. Start growing your channel today!
          </p>
          <PlayStoreButton />
        </div>
        <div className="home-image">
          <img
            src="assets/images/home_logo.png"
            alt="GrowTube App"
            className="app-img"
            loading="lazy"
          />
        </div>
      </div>
    </section>
  );
};

export default HomePage;
